module.exports = __webpack_public_path__ + "static/media/skck.58b61a7a.png";